<template>
  <v-container id="requisicao" fill-height fluid grid-list-xl tag="section">
    <v-layout justify-center wrap>
      <v-flex xs12 md12 sm12>
        <div class="text-center ma-2">
          <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout" top>
            {{ textSnackbar }}
            <v-btn class="mx-2" fab small color="white" text @click="snackbar = false" dark>
              <v-icon dark>mdi-close-thick</v-icon>
            </v-btn>
          </v-snackbar>
        </div>
        <v-card>
          <div>
            <v-dialog v-model="loading" hide-overlay persistent width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  Buscando informações, aguarde ...
                  <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <filtro-requisicao v-on:add-filtro-requisicao="listarRequisicao" />
          <v-card color="grey lighten-5">
            <v-card-title>Requisição</v-card-title>
          </v-card>
          <v-form>
            <v-container>
              <v-row dense>
                <v-col cols="12" md="2" sm="1" xs="1">
                  <v-text-field v-model="textRequisicaoConcat" label="Loja/Orçamento/Serie"></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="2" xs="2">
                  <v-text-field v-model="requisicao[0].dtcad" label="Emissão"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="4" xs="4">
                  <v-text-field v-model="textFuncionario" label="Funcionário"></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="3" xs="3">
                  <v-text-field v-model="textCanalCaptacao" label="Canal Captação"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" md="5" sm="5" xs="5">
                  <v-text-field v-model=" textCliente" label="Cliente"></v-text-field>
                </v-col>
                <v-col cols="12" md="2" sm="2" xs="2">
                  <v-text-field v-model="textClasse" label="Classe"></v-text-field>
                </v-col>
                <v-col cols="12" md="5" sm="5" xs="5">
                  <v-text-field v-model="textProfissional" label="Profissional"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" md="4" sm="1" xs="1">
                  <v-text-field v-model="textForma" label="Forma / Volume"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textCompra" label="Compra"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textCusto" label="Custo"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textFator" label="Fator"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textPercTaxa" label="% Taxa"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textTaxa" label="Taxa"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textPercDesc" label="% Desc."></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textDesc" label="Desc."></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textVenda" label="Venda"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-divider></v-divider>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Tp</th>
                  <th class="text-left">Codigo</th>
                  <th class="text-left">Produto</th>
                  <th class="text-left">Qsp</th>
                  <th class="text-right">Qt-U</th>
                  <th class="text-center">Un</th>
                  <th class="text-right">Qt-T</th>
                  <th class="text-center">Compra</th>
                  <th class="text-center">Custo</th>
                  <th class="text-center">Fator</th>
                  <th class="text-center">Venda</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in itensRequisicao" :key="item.itemid">
                  <td>{{item.tpcmp}}</td>
                  <td>{{item.cdprin}}</td>
                  <td>{{item.descrprd}}</td>
                  <td>{{item.indqsp}}</td>
                  <td class="text-right">{{item.quant}}</td>
                  <td class="text-right">{{item.unida}}</td>
                  <td class="text-right">{{item.qtreal}}</td>
                  <td class="text-right">{{item.prcompra | dinheiro}}</td>
                  <td class="text-right">{{item.prcusto | dinheiro}}</td>
                  <td class="text-right">{{item.fator}}</td>
                  <td class="text-right">{{item.vrvenda | dinheiro}}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FiltroRequisicao from "../components/filtros/FiltroRequisicao";
import { mapGetters } from "vuex";

export default {
  components: {
    FiltroRequisicao
  },
  data: () => ({
    requisicao: [
      {
        cdfil: null,
        nrrqu: null,
        serier: null,
        cdfunre: null,
        nomefun: null,
        cdcaptacao: null,
        canal: null,
        cdcli: null,
        nomecli: null,
        pfcrm: null,
        classeCrm: null,
        nrcrm: null,
        ufcrm: null,
        nomemed: null,
        tpformafarma: null,
        forma_farmaceutica: null,
        univol: null,
        prcompra: null,
        prcusto: null,
        fator: null,
        pttxt: null,
        vrtxa: null,
        ptdsc: null,
        vrdec: null,
        prreal: null,
        prvenda: null,
        fatorV: null
      }
    ],
    itensRequisicao: [],
    loading: false,
    errored: false,
    snackbar: false,
    textSnackbar: "",
    snackbarColor: "",
    timeout: 10000
  }),
  mounted() {
    if (this.filtroRequisicaoStore.length) {
      this.loading = true;
      this.buscarRequisicaoViaLista();
    }
  },
  computed: {
    ...mapGetters({
      filtroRequisicaoStore: "filtroRequisicao"
    }),
    textRequisicaoConcat: {
      get() {
        if (this.requisicao[0].cdfil != null) {
          return `${this.requisicao[0].cdfil} - ${this.requisicao[0].nrrqu} - ${this.requisicao[0].serier}`;
        } else {
          return "";
        }
      }
    },
    textFuncionario: {
      get() {
        if (this.requisicao[0].cdfunre != null) {
          return `${this.requisicao[0].cdfunre} - ${this.requisicao[0].nomefun}`;
        } else {
          return "";
        }
      }
    },
    textCanalCaptacao: {
      get() {
        if (this.requisicao[0].cdcaptacao != null) {
          return `${this.requisicao[0].cdcaptacao} - ${this.requisicao[0].canal}`;
        } else {
          return "";
        }
      }
    },
    textCliente: {
      get() {
        if (this.requisicao[0].cdcli != null) {
          return `${this.requisicao[0].cdcli} - ${this.requisicao[0].nomecli}`;
        } else {
          return "";
        }
      }
    },
    textClasse: {
      get() {
        if (this.requisicao[0].pfcrm != null) {
          return `${this.requisicao[0].pfcrm} - ${this.requisicao[0].classeCrm}`;
        } else {
          return "";
        }
      }
    },
    textProfissional: {
      get() {
        if (this.requisicao[0].pfcrm != null) {
          return `${this.requisicao[0].nrcrm}/${this.requisicao[0].ufcrm} - ${this.requisicao[0].nomemed}`;
        } else {
          return "";
        }
      }
    },
    textForma: {
      get() {
        if (this.requisicao[0].tpformafarma != null) {
          return `${this.requisicao[0].tpformafarma} - ${this.requisicao[0].forma_farmaceutica} - ${this.requisicao[0].univol}`;
        } else {
          return "";
        }
      }
    },
    textCompra: {
      get() {
        if (this.requisicao[0].prcompra != null) {
          return `${parseFloat(this.requisicao[0].prcompra).toFixed(
            2
          )}`.replace(".", ",");
        } else {
          return "";
        }
      }
    },
    textCusto: {
      get() {
        if (this.requisicao[0].prcusto != null) {
          return `${parseFloat(this.requisicao[0].prcusto).toFixed(2)}`.replace(
            ".",
            ","
          );
        } else {
          return "";
        }
      }
    },
    textFator: {
      get() {
        if (this.requisicao[0].fatorV) {
          return `${parseFloat(this.requisicao[0].fatorV).toFixed(2)}`;
        } else {
          return "";
        }
      }
    },
    textPercTaxa: {
      get() {
        if (this.requisicao[0].pttxa != null) {
          return `% ${parseFloat(this.requisicao[0].pttxa).toFixed(2)}`;
        } else {
          return "";
        }
      }
    },
    textTaxa: {
      get() {
        if (this.requisicao[0].vrtxa) {
          return `${parseFloat(this.requisicao[0].vrtxa).toFixed(2)}`.replace(
            ".",
            ","
          );
        } else {
          return "";
        }
      }
    },
    textPercDesc: {
      get() {
        if (this.requisicao[0].ptdsc) {
          return `% ${parseFloat(this.requisicao[0].ptdsc).toFixed(2)}`;
        } else {
          return "";
        }
      }
    },
    textDesc: {
      get() {
        if (this.requisicao[0].vrdsc != null) {
          return `${parseFloat(this.requisicao[0].vrdsc).toFixed(2)}`.replace(
            ".",
            ","
          );
        } else {
          return "";
        }
      }
    },
    textVenda: {
      get() {
        if (this.requisicao[0].prvenda != null) {
          return `${parseFloat(this.requisicao[0].prvenda).toFixed(2)}`.replace(
            ".",
            ","
          );
        } else {
          return "";
        }
      }
    }
  },
  watch: {
    filtroRequisicaoStore: function() {
      this.loading = true;
      this.buscarRequisicaoViaLista();
    }
  },
  methods: {
    listarRequisicao(dados) {
      this.$http
        .get("requisicao", {
          params: {
            loja: dados.loja,
            requisicao: dados.requisicao,
            serie: dados.serie
          }
        })
        .then(res => {
          this.itensRequisicao = res.data.itensRequisicao;
          this.requisicao = res.data.requisicao;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 400) {
              this.textSnackbar = error.response.data[0].message;
              this.snackbar = true;
              this.snackbarColor = "error";
            }
          }
        })
        .finally(() => (this.loading = false));
    },
    buscarRequisicaoViaLista() {
      this.$http
        .get("requisicao", {
          params: {
            loja: this.filtroRequisicaoStore[0],
            requisicao: this.filtroRequisicaoStore[1],
            serie: this.filtroRequisicaoStore[2]
          }
        })
        .then(res => {
          this.itensRequisicao = res.data.itensRequisicao;
          this.requisicao = res.data.requisicao;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 400) {
              this.textSnackbar = error.response.data[0].message;
              this.snackbar = true;
              this.snackbarColor = "error";
            }
          }
        })
        .finally(() => (this.loading = false));
    },
    limpaReqView() {
      this.listarRequisicao = [];
    }
  }
};
</script>

<style>
</style>